import ApiClinet from 'clients/api_client'
import Offer from 'entities/offer'
import Pagination from 'entities/pagination'

export default class PageClient {
  static getOfferPages(companyToken, groupToken, recruiterToken = null) {
    const url = Routes.offersPagesPath({
      token_company: companyToken,
      token_group: groupToken,
      token_recruiter: recruiterToken,
      page: 1
    })

    return ApiClinet.get(url).then(({ data, headers }) => ({
      offers: data.map(offer => new Offer(offer)),
      pagination: Pagination.fromJsonLowerCased(headers)
    }))
  }
}
